import { IBericht } from '@/model/IBericht';
import { Component, Mixins } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import { Action, State } from 'vuex-class';
import { filter, find, findIndex } from 'lodash';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import VueMarkdown from 'vue-markdown';
import { IDocument } from '@/model/IDocument';
import { appDocumentenService } from '@/services/appDocumentenService';
import { appDownloadService } from '@/services/appDownloadService';
import { tjipBusyService } from '@/services/tjipBusyService';

@Component({
  components: {
    'vue-markdown': VueMarkdown
  }
})
export default class AppBerichten extends Mixins(AppHypotheekMixin, AppFiltersMixin) {
  private timeoutHandle!: number;
  private activeTabIndex = 0;

  @State(state => state.berichten)
  public berichten!: IBericht[];
  @Action('berichten/markAsRead')
  private markAsRead!: (bericht: IBericht) => Promise<void>;

  public isOngelezen(bericht: IBericht) {
    return !bericht.gelezen || !!find(bericht.documenten, d => !d.gelezen);
  }

  public get unreadBerichten(): IBericht[] {
    return filter(this.berichten || [], b => this.isOngelezen(b));
  }

  public get hasNone(): boolean {
    return !this.berichten.length;
  }

  public get hasMore(): boolean {
    return this.berichten.length > 2;
  }

  public isActive(index: number): boolean {
    return this.activeTabIndex === index;
  }

  public activateTab(newTabIndex: number) {
    this.activeTabIndex = Math.max(newTabIndex, 0);
    const bericht = this.berichten[newTabIndex];
    clearTimeout(this.timeoutHandle);
    if (newTabIndex >= 0) {
      this.timeoutHandle = setTimeout(() => {
        this.markAsRead(bericht);
      }, 3000);
    }
  }

  openBericht(index: number) {
    this.$root.$emit('bv::toggle::collapse', index < 0 ? 'berichten' : `bericht-${index}`);
    if (index >= 0) {
      const bericht = this.berichten[index];
      this.markAsRead(bericht);
    }
  }

  created() {
    const index = parseInt(this.$route.query.n as string, 10) || 0;
    if (index < this.unreadBerichten.length) {
      const b1 = this.unreadBerichten[index];
      this.activateTab(findIndex(this.berichten, b2 => b1 === b2));
    } else {
      this.activateTab(0);
    }
  }

  download(document: IDocument): void {
    tjipBusyService.add(
      appDocumentenService
        .downloadDocument(document.documentId)
        .then(blob => {
          return appDownloadService.saveDocument(blob, document.bestandsnaam);
        })
        .then(() => {
          document.gelezen = true;
        })
    );
  }
}
